import { User } from "../models/Person";

/** Guests must not appear in homepage featured grids; Browse People includes them via search API. */
export function filterDirectoryProfiles(profiles: User[] | undefined | null): User[] {
  if (!profiles?.length) {
    return [];
  }
  return profiles.filter((profile) => !profile.isGuest);
}
